import { render, staticRenderFns } from "./ExchangeFormBank.vue?vue&type=template&id=390fe86e"
import script from "./ExchangeFormBank.vue?vue&type=script&lang=js"
export * from "./ExchangeFormBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports